/**
 * My Lettaga Feature Routes
 * 라우트는 항상 등록. 좌측메뉴는 VerticalSidebar에서 구독 무관 노출.
 * 구독/feature 확인창은 페이지 ensureAccess(useMyLettagaAccess)가 담당.
 * 부서 mylSaved(PRV025~028 저장)일 때만 view 검사, 아니면 통과.
 */

import type { RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useSessionStore } from '@/shared/stores/sessionStore';
import {
  checkMenuViewPermission,
  hasAnyMyLettagaMenuConfigured,
} from '@/shared/utils/permissionUtils';

/** 권한 ON + mylSaved 일 때만 view 게이트. 구독 확인창은 페이지 ensureAccess. */
const requireMyLettaga = async (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const sessionStore = useSessionStore();
    const permissions = sessionStore.getPermissions as any;
    // 권한관리 OFF면 메뉴 view 게이트 생략
    if (!permissions?.isAuthEnabled) {
        next();
        return;
    }

    // 부서에 My Lettaga(PRV025~028) 미저장 → 통과
    if (!hasAnyMyLettagaMenuConfigured(permissions)) {
        next();
        return;
    }

    // 부모 PRV025 (/mylettaga) — L_MENU에 키가 있을 때만 검사
    const parentMenu = permissions?.menus?.['/mylettaga'];
    if (parentMenu && parentMenu.view !== true) {
        next({ path: '/dashboard', replace: true });
        return;
    }

    if (!checkMenuViewPermission(permissions, to.path)) {
        next({ path: '/dashboard', replace: true });
        return;
    }

    next();
};

export const myLettagaRoutes: RouteRecordRaw[] = [
    {
        path: '/mylettaga/members',
        name: 'MyLettagaMembers',
        component: () => import('./views/MembersView.vue'),
        beforeEnter: requireMyLettaga,
        meta: {
            title: 'My Lettaga · Members',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/mylettaga/chat',
        name: 'MyLettagaChat',
        component: () => import('./views/ChatView.vue'),
        beforeEnter: requireMyLettaga,
        meta: {
            title: 'My Lettaga · Chat',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        // 운영 설정(ops)은 통합 Settings(/settings/my-lettaga)로 이관됨.
        // 옛 경로는 리다이렉트 — 북마크 및 구독뷰 뒤로가기(backTo='/mylettaga/settings') 호환.
        path: '/mylettaga/settings',
        redirect: '/settings/my-lettaga'
    },
    {
        // 구독 상세(market) — 구독·결제·화이트라벨. Marketplace 카드 진입점 → 가드 없음(미구독자도 구독하러 접근).
        path: '/mylettaga/subscription',
        name: 'MyLettagaSubscription',
        component: () => import('./views/SettingsView.vue'),
        meta: {
            title: 'My Lettaga · Subscription',
            requiresAuth: true,
            layout: 'default',
        },
    },
];
